import { render } from "./feedBackListView.vue?vue&type=template&id=3c854280&scoped=true"
import script from "./feedBackListView.vue?vue&type=script&lang=js"
export * from "./feedBackListView.vue?vue&type=script&lang=js"

import "./feedBackListView.vue?vue&type=style&index=0&id=3c854280&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c854280"

export default script